// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RangeAnalysisTab_ace_container__z1YkZ {
  padding: 0 1rem 1rem 1rem;
  min-height: 100vh;
}

.RangeAnalysisTab_ace_cardTitle__AumLC {
  color: #364e69;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_ace_performanceToggleBtn__MzOHA {
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_performanceToggleBtn__MzOHA:focus,
.RangeAnalysisTab_ace_performanceToggleBtn__MzOHA:active {
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_performanceToggleBtnActive__3Q\\+nt:hover,
.RangeAnalysisTab_ace_performanceToggleBtnActive__3Q\\+nt:focus,
.RangeAnalysisTab_ace_performanceToggleBtnActive__3Q\\+nt:active,
.RangeAnalysisTab_ace_performanceToggleBtnInactive__ymtYL:hover,
.RangeAnalysisTab_ace_performanceToggleBtnInactive__ymtYL:focus,
.RangeAnalysisTab_ace_performanceToggleBtnInactive__ymtYL:active {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_performanceToggleBtnActive__3Q\\+nt {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
}



.RangeAnalysisTab_ace_performanceToggleBtnInactive__ymtYL {
  background-color: transparent !important;
  border-color: #358696 !important;
  color: #358696 !important;
}

.RangeAnalysisTab_ace_btn-check__Vyeoa:checked+.RangeAnalysisTab_ace_btn__svUZG,
.RangeAnalysisTab_ace_btn-check__Vyeoa:active+.RangeAnalysisTab_ace_btn__svUZG,
.RangeAnalysisTab_ace_btn__svUZG.RangeAnalysisTab_ace_active__M6k6E,
.RangeAnalysisTab_ace_btn__svUZG.RangeAnalysisTab_ace_show__22k2S,
.RangeAnalysisTab_ace_btn__svUZG:first-child:active,
:not(.RangeAnalysisTab_ace_btn-check__Vyeoa)+.RangeAnalysisTab_ace_btn__svUZG:active {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_btn-group__1hQta .RangeAnalysisTab_ace_btn__svUZG:focus,
.RangeAnalysisTab_ace_btn-group__1hQta .RangeAnalysisTab_ace_btn__svUZG:active {
  background-color: inherit !important;
  color: inherit !important;
  box-shadow: none !important;
}

.RangeAnalysisTab_ace_performanceCard__pMuDq {
  min-height: 100%;
}

.RangeAnalysisTab_ace_performanceCardTitle__rHZFu {
  color: #364e69;
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-transform: none;
  /* Add this line */
}

.RangeAnalysisTab_ace_vehicleRankCard__x8INE {
  background-color: #358696;
  border: 0;
  margin-bottom: 0.5rem;
}

.RangeAnalysisTab_ace_vehicleRankActive__Ez3qg {
  background-color: #054e5d;
  border: 0;
  margin-bottom: 0.5rem;
}

.RangeAnalysisTab_ace_vehicleRankCardBody__9IeJj {
  padding: 0.5rem 0.75rem;
}

.RangeAnalysisTab_ace_rankBadge__gqC\\+E {
  background-color: white !important;
  color: #358696 !important;
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 14px !important;
  font-weight: bold !important;
  flex-shrink: 0 !important;
  border: none !important;
}

.RangeAnalysisTab_ace_vehicleRankText__NdTpa {
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
}

.RangeAnalysisTab_ace_vehicleRankSubtext__pP3\\+9 {
  color: white;
  font-size: 0.75rem;
}

.RangeAnalysisTab_ace_energyEfficiencyText__NcVgr {
  color: white;
  font-size: 0.85rem;
  font-weight: bold;
}

.RangeAnalysisTab_ace_energyEfficiencySubtext__\\+3ULJ {
  color: white;
  font-size: 0.7rem;
}

.RangeAnalysisTab_ace_metricsContainer__vjlXO {
  min-width: 180px;
}

.RangeAnalysisTab_ace_mainMetric__0b7ux {
  color: #364e69;
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_ace_mainMetricSmall__fXnto {
  color: #364e69;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0;
}

.RangeAnalysisTab_ace_mainMetricLabel__U4IPw {
  color: #364e69;
  font-size: 0.75rem;
}

/* New styles for the metrics card */
.RangeAnalysisTab_ace_metricsCard__Qzr-B {
  background-color: #358696;
  border: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.RangeAnalysisTab_ace_metricsCardBody__AGgUV {
  padding: 1rem;
}

.RangeAnalysisTab_ace_performanceIndicatorCard__IJfDK {
  height: 90px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 0;
}

.RangeAnalysisTab_ace_performanceIndicatorCardTransparent__MWEql {
  height: 90px;
  /* background-color: white; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  /* border: 0; */
}

.RangeAnalysisTab_ace_performanceIndicatorIcon__Gfwbz {
  color: #358696;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.RangeAnalysisTab_ace_performanceIndicatorTitle__kLczx {
  font-size: 0.85rem;
  font-weight: 500;
}

.RangeAnalysisTab_ace_performanceIndicatorValue__ckGuB {
  font-size: 0.72rem;
}

.RangeAnalysisTab_ace_tableToggleBtn__dE7J9 {
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_tableToggleBtn__dE7J9:hover,
.RangeAnalysisTab_ace_tableToggleBtn__dE7J9:focus,
.RangeAnalysisTab_ace_tableToggleBtn__dE7J9:active {
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_tableToggleBtnActive__wrC\\+H {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
}

.RangeAnalysisTab_ace_tableToggleBtnActive__wrC\\+H:hover,
.RangeAnalysisTab_ace_tableToggleBtnActive__wrC\\+H:focus,
.RangeAnalysisTab_ace_tableToggleBtnActive__wrC\\+H:active {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_tableToggleBtnInactive__0Rc2K {
  background-color: transparent !important;
  border-color: #358696 !important;
  color: #358696 !important;
}

.RangeAnalysisTab_ace_tableToggleBtnInactive__0Rc2K:hover,
.RangeAnalysisTab_ace_tableToggleBtnInactive__0Rc2K:focus,
.RangeAnalysisTab_ace_tableToggleBtnInactive__0Rc2K:active {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

.RangeAnalysisTab_ace_tableHeader__BQc7J {
  background-color: #358696;
}

.RangeAnalysisTab_ace_tableHeaderText__-sSQx {
  color: white;
  font-weight: 600;
}

.RangeAnalysisTab_ace_vehicleDetailsText__RJ2lB {
  font-weight: 600;
  color: #425872;
}

.RangeAnalysisTab_ace_energyConsumptionText__BqwKL {
  font-weight: 500;
}

.RangeAnalysisTab_ace_energyEfficiencyText__NcVgr {
  font-weight: 500;
}

.RangeAnalysisTab_ace_metricsRow__gYowO {
  padding: 1rem 0;
}

.RangeAnalysisTab_ace_metricItem__KreLM {
  text-align: center;
  min-height: 100%;
}

.RangeAnalysisTab_ace_metricLabel__ZrzIa {
  color: #364e69;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.RangeAnalysisTab_ace_metricValue__\\+X11H {
  color: #364e69;
  font-size: 1rem;
  font-weight: bold;
}

.RangeAnalysisTab_ace_downloadBtn__vnm0Z {
  border: 1px solid #358696 !important;
  color: #358696 !important;
  background-color: transparent !important;
  transition: all 0.2s ease;
}

.RangeAnalysisTab_ace_downloadBtn__vnm0Z:hover,
.RangeAnalysisTab_ace_downloadBtn__vnm0Z:focus,
.RangeAnalysisTab_ace_downloadBtn__vnm0Z:active {
  background-color: #358696 !important;
  border-color: #358696 !important;
  color: white !important;
  box-shadow: none !important;
  outline: none !important;
}

/* Add this new class for smaller metric values */
.RangeAnalysisTab_ace_metricValueSmall__apJfU {
  color: #364e69;
  font-size: 0.75rem;
  font-weight: bold;
}

/* Styles for rows with dropdown arrows */
.RangeAnalysisTab_ace_tableRowWithDropdown__upC5e {
  cursor: pointer;
}

.RangeAnalysisTab_ace_dropdownArrow__3GwTS {
  position: absolute;
  right: 15px;
  top: 30%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.RangeAnalysisTab_ace_tableRowWithDropdown__upC5e:hover .RangeAnalysisTab_ace_dropdownArrow__3GwTS {
  opacity: 0.7;
}

.RangeAnalysisTab_ace_tableCards__fy6dZ {
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
}

.RangeAnalysisTab_ace_tableCardBorder__cErJm {

  background-color: #f1f5f9;
  padding: 12px 5px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  text-align: 'center'

}

.RangeAnalysisTab_ace_brandColor__5y\\+3H {
  color: #358696 !important;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/MileageSaarathiAce/RangeAnalysisTab_ace/RangeAnalysisTab_ace.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;;;AAIA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;;;;EAME,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8CAA8C;EAC9C,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;EAGE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB;;AAEF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  padding: 0 1rem 1rem 1rem;\n  min-height: 100vh;\n}\n\n.cardTitle {\n  color: #364e69;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.performanceToggleBtn {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceToggleBtn:focus,\n.performanceToggleBtn:active {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceToggleBtnActive:hover,\n.performanceToggleBtnActive:focus,\n.performanceToggleBtnActive:active,\n.performanceToggleBtnInactive:hover,\n.performanceToggleBtnInactive:focus,\n.performanceToggleBtnInactive:active {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.performanceToggleBtnActive {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n}\n\n\n\n.performanceToggleBtnInactive {\n  background-color: transparent !important;\n  border-color: #358696 !important;\n  color: #358696 !important;\n}\n\n.btn-check:checked+.btn,\n.btn-check:active+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.btn-group .btn:focus,\n.btn-group .btn:active {\n  background-color: inherit !important;\n  color: inherit !important;\n  box-shadow: none !important;\n}\n\n.performanceCard {\n  min-height: 100%;\n}\n\n.performanceCardTitle {\n  color: #364e69;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  text-transform: none;\n  /* Add this line */\n}\n\n.vehicleRankCard {\n  background-color: #358696;\n  border: 0;\n  margin-bottom: 0.5rem;\n}\n\n.vehicleRankActive {\n  background-color: #054e5d;\n  border: 0;\n  margin-bottom: 0.5rem;\n}\n\n.vehicleRankCardBody {\n  padding: 0.5rem 0.75rem;\n}\n\n.rankBadge {\n  background-color: white !important;\n  color: #358696 !important;\n  width: 30px !important;\n  height: 30px !important;\n  border-radius: 50% !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  font-size: 14px !important;\n  font-weight: bold !important;\n  flex-shrink: 0 !important;\n  border: none !important;\n}\n\n.vehicleRankText {\n  color: white;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.vehicleRankSubtext {\n  color: white;\n  font-size: 0.75rem;\n}\n\n.energyEfficiencyText {\n  color: white;\n  font-size: 0.85rem;\n  font-weight: bold;\n}\n\n.energyEfficiencySubtext {\n  color: white;\n  font-size: 0.7rem;\n}\n\n.metricsContainer {\n  min-width: 180px;\n}\n\n.mainMetric {\n  color: #364e69;\n  font-size: 1.8rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.mainMetricSmall {\n  color: #364e69;\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.mainMetricLabel {\n  color: #364e69;\n  font-size: 0.75rem;\n}\n\n/* New styles for the metrics card */\n.metricsCard {\n  background-color: #358696;\n  border: 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.metricsCardBody {\n  padding: 1rem;\n}\n\n.performanceIndicatorCard {\n  height: 90px;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 0;\n}\n\n.performanceIndicatorCardTransparent {\n  height: 90px;\n  /* background-color: white; */\n  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */\n  /* border: 0; */\n}\n\n.performanceIndicatorIcon {\n  color: #358696;\n  font-size: 1.1rem;\n  margin-bottom: 0.25rem;\n}\n\n.performanceIndicatorTitle {\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.performanceIndicatorValue {\n  font-size: 0.72rem;\n}\n\n.tableToggleBtn {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableToggleBtn:hover,\n.tableToggleBtn:focus,\n.tableToggleBtn:active {\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableToggleBtnActive {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n}\n\n.tableToggleBtnActive:hover,\n.tableToggleBtnActive:focus,\n.tableToggleBtnActive:active {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableToggleBtnInactive {\n  background-color: transparent !important;\n  border-color: #358696 !important;\n  color: #358696 !important;\n}\n\n.tableToggleBtnInactive:hover,\n.tableToggleBtnInactive:focus,\n.tableToggleBtnInactive:active {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.tableHeader {\n  background-color: #358696;\n}\n\n.tableHeaderText {\n  color: white;\n  font-weight: 600;\n}\n\n.vehicleDetailsText {\n  font-weight: 600;\n  color: #425872;\n}\n\n.energyConsumptionText {\n  font-weight: 500;\n}\n\n.energyEfficiencyText {\n  font-weight: 500;\n}\n\n.metricsRow {\n  padding: 1rem 0;\n}\n\n.metricItem {\n  text-align: center;\n  min-height: 100%;\n}\n\n.metricLabel {\n  color: #364e69;\n  font-size: 0.9rem;\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n.metricValue {\n  color: #364e69;\n  font-size: 1rem;\n  font-weight: bold;\n}\n\n.downloadBtn {\n  border: 1px solid #358696 !important;\n  color: #358696 !important;\n  background-color: transparent !important;\n  transition: all 0.2s ease;\n}\n\n.downloadBtn:hover,\n.downloadBtn:focus,\n.downloadBtn:active {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n  color: white !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n/* Add this new class for smaller metric values */\n.metricValueSmall {\n  color: #364e69;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n\n/* Styles for rows with dropdown arrows */\n.tableRowWithDropdown {\n  cursor: pointer;\n}\n\n.dropdownArrow {\n  position: absolute;\n  right: 15px;\n  top: 30%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tableRowWithDropdown:hover .dropdownArrow {\n  opacity: 0.7;\n}\n\n.tableCards {\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.tableCardBorder {\n\n  background-color: #f1f5f9;\n  padding: 12px 5px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  text-align: 'center'\n\n}\n\n.brandColor {\n  color: #358696 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RangeAnalysisTab_ace_container__z1YkZ`,
	"cardTitle": `RangeAnalysisTab_ace_cardTitle__AumLC`,
	"performanceToggleBtn": `RangeAnalysisTab_ace_performanceToggleBtn__MzOHA`,
	"performanceToggleBtnActive": `RangeAnalysisTab_ace_performanceToggleBtnActive__3Q+nt`,
	"performanceToggleBtnInactive": `RangeAnalysisTab_ace_performanceToggleBtnInactive__ymtYL`,
	"btn-check": `RangeAnalysisTab_ace_btn-check__Vyeoa`,
	"btn": `RangeAnalysisTab_ace_btn__svUZG`,
	"active": `RangeAnalysisTab_ace_active__M6k6E`,
	"show": `RangeAnalysisTab_ace_show__22k2S`,
	"btn-group": `RangeAnalysisTab_ace_btn-group__1hQta`,
	"performanceCard": `RangeAnalysisTab_ace_performanceCard__pMuDq`,
	"performanceCardTitle": `RangeAnalysisTab_ace_performanceCardTitle__rHZFu`,
	"vehicleRankCard": `RangeAnalysisTab_ace_vehicleRankCard__x8INE`,
	"vehicleRankActive": `RangeAnalysisTab_ace_vehicleRankActive__Ez3qg`,
	"vehicleRankCardBody": `RangeAnalysisTab_ace_vehicleRankCardBody__9IeJj`,
	"rankBadge": `RangeAnalysisTab_ace_rankBadge__gqC+E`,
	"vehicleRankText": `RangeAnalysisTab_ace_vehicleRankText__NdTpa`,
	"vehicleRankSubtext": `RangeAnalysisTab_ace_vehicleRankSubtext__pP3+9`,
	"energyEfficiencyText": `RangeAnalysisTab_ace_energyEfficiencyText__NcVgr`,
	"energyEfficiencySubtext": `RangeAnalysisTab_ace_energyEfficiencySubtext__+3ULJ`,
	"metricsContainer": `RangeAnalysisTab_ace_metricsContainer__vjlXO`,
	"mainMetric": `RangeAnalysisTab_ace_mainMetric__0b7ux`,
	"mainMetricSmall": `RangeAnalysisTab_ace_mainMetricSmall__fXnto`,
	"mainMetricLabel": `RangeAnalysisTab_ace_mainMetricLabel__U4IPw`,
	"metricsCard": `RangeAnalysisTab_ace_metricsCard__Qzr-B`,
	"metricsCardBody": `RangeAnalysisTab_ace_metricsCardBody__AGgUV`,
	"performanceIndicatorCard": `RangeAnalysisTab_ace_performanceIndicatorCard__IJfDK`,
	"performanceIndicatorCardTransparent": `RangeAnalysisTab_ace_performanceIndicatorCardTransparent__MWEql`,
	"performanceIndicatorIcon": `RangeAnalysisTab_ace_performanceIndicatorIcon__Gfwbz`,
	"performanceIndicatorTitle": `RangeAnalysisTab_ace_performanceIndicatorTitle__kLczx`,
	"performanceIndicatorValue": `RangeAnalysisTab_ace_performanceIndicatorValue__ckGuB`,
	"tableToggleBtn": `RangeAnalysisTab_ace_tableToggleBtn__dE7J9`,
	"tableToggleBtnActive": `RangeAnalysisTab_ace_tableToggleBtnActive__wrC+H`,
	"tableToggleBtnInactive": `RangeAnalysisTab_ace_tableToggleBtnInactive__0Rc2K`,
	"tableHeader": `RangeAnalysisTab_ace_tableHeader__BQc7J`,
	"tableHeaderText": `RangeAnalysisTab_ace_tableHeaderText__-sSQx`,
	"vehicleDetailsText": `RangeAnalysisTab_ace_vehicleDetailsText__RJ2lB`,
	"energyConsumptionText": `RangeAnalysisTab_ace_energyConsumptionText__BqwKL`,
	"metricsRow": `RangeAnalysisTab_ace_metricsRow__gYowO`,
	"metricItem": `RangeAnalysisTab_ace_metricItem__KreLM`,
	"metricLabel": `RangeAnalysisTab_ace_metricLabel__ZrzIa`,
	"metricValue": `RangeAnalysisTab_ace_metricValue__+X11H`,
	"downloadBtn": `RangeAnalysisTab_ace_downloadBtn__vnm0Z`,
	"metricValueSmall": `RangeAnalysisTab_ace_metricValueSmall__apJfU`,
	"tableRowWithDropdown": `RangeAnalysisTab_ace_tableRowWithDropdown__upC5e`,
	"dropdownArrow": `RangeAnalysisTab_ace_dropdownArrow__3GwTS`,
	"tableCards": `RangeAnalysisTab_ace_tableCards__fy6dZ`,
	"tableCardBorder": `RangeAnalysisTab_ace_tableCardBorder__cErJm`,
	"brandColor": `RangeAnalysisTab_ace_brandColor__5y+3H`
};
export default ___CSS_LOADER_EXPORT___;
